import script from "./VirtualAccountDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualAccountDisplay.vue?vue&type=script&setup=true&lang=js"

import "./VirtualAccountDisplay.vue?vue&type=style&index=0&id=385b079d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-385b079d"]])

export default __exports__